import { IupTemplateBuilding } from "../models/upTemplate.model";

const coverIndustrialTemplate = (buildingGroups: IupTemplateBuilding[]) => {
  return buildingGroups.map(building => {
    return {
      nameBuilding: building.name,
      deliveryDate: new Date(building.date),
      units: building.units.map((unit: any) => {
        return {
          name: unit[0],
          bedrooms: floatToInteger(unit[1]),
          bathrooms: floatToInteger(unit[2]),
          half_bathrooms: unit[3],
          parking: floatToInteger(unit[4]),
          level: 0,
          land_area: floatToInteger(unit[5]),
          construction_area: floatToInteger(unit[6]),
          currency: unit[7],
          price: floatToInteger(unit[8])
        };
      })
    };
  });
};

const coverApartmentTemplate = (buildingGroups: IupTemplateBuilding[]) => {
  return buildingGroups.map(building => {
    return {
      nameBuilding: building.name,
      deliveryDate: new Date(building.date),
      units: building.units.map((unit: any) => {
        return {
          name: unit[0],
          bedrooms: floatToInteger(unit[1]),
          bathrooms: floatToInteger(unit[2]),
          half_bathrooms: unit[3],
          parking: floatToInteger(unit[4]),
          level: floatToInteger(unit[5]),
          land_area: floatToInteger(unit[6]),
          construction_area: floatToInteger(unit[7]),
          currency: unit[8],
          price: floatToInteger(unit[9])
        };
      })
    };
  });
};

const coverComercialSiteTemplate = (buildingGroups: IupTemplateBuilding[]) => {
  return buildingGroups.map(building => {
    return {
      nameBuilding: building.name,
      deliveryDate: new Date(building.date),
      units: building.units.map((unit: any) => {
        return {
          name: unit[0],
          bedrooms: 0,
          bathrooms: floatToInteger(unit[1]),
          half_bathrooms: unit[2],
          parking: floatToInteger(unit[3]),
          level: floatToInteger(unit[4]),
          land_area: floatToInteger(unit[5]),
          construction_area: floatToInteger(unit[6]),
          currency: unit[7],
          price: floatToInteger(unit[8])
        };
      })
    };
  });
};

const coverLandTemplate = (buildingGroups: IupTemplateBuilding[]) => {
  return buildingGroups.map(building => {
    return {
      nameBuilding: building.name,
      deliveryDate: new Date(building.date),
      units: building.units.map((unit: any) => {
        return {
          name: unit[0],
          bedrooms: 0,
          bathrooms: 0,
          half_bathrooms: 0,
          parking: 0,
          level: 0,
          land_area: floatToInteger(unit[1]),
          construction_area: 0,
          currency: unit[2],
          price: floatToInteger(unit[3])
        };
      })
    };
  });
};

const coverHouseTemplate = (buildingGroups: IupTemplateBuilding[]) => {
  return buildingGroups.map(building => {
    return {
      nameBuilding: building.name,
      deliveryDate: new Date(building.date),
      units: building.units.map((unit: any) => {
        return {
          name: unit[0],
          bedrooms: floatToInteger(unit[1]),
          bathrooms: floatToInteger(unit[2]),
          half_bathrooms: unit[3],
          parking: floatToInteger(unit[4]),
          level: 0,
          land_area: floatToInteger(unit[5]),
          construction_area: floatToInteger(unit[6]),
          currency: unit[7],
          price: floatToInteger(unit[8])
        };
      })
    };
  });
};

const floatToInteger = (value: string | number | null) => {
  if (value === null) return 0;
  return Number(value).toFixed(0);
};

const convertToNumber = (value: string | number | null) => {
  if (value === null) return 0;
  return Number(value);
};
const convertToFloat = (value: string | number | null) => {
  if (value === null) return 0;
  return Number(value).toFixed(1);
};

export {
  coverIndustrialTemplate,
  coverApartmentTemplate,
  coverComercialSiteTemplate,
  coverLandTemplate,
  coverHouseTemplate
};
